import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@material-ui/core/Icon';
import { IoMdCamera, IoMdMic, IoMdText } from 'react-icons/io';
import { Tooltip } from '@material-ui/core';
import ButtonItem from './components/ButtonItem';

import { Container } from './styles';

const options = [
  {
    icon: <Icon className="icon-blood-person" />,
    label: 'Região do sangramento',
  },
  {
    icon: <IoMdCamera />,
    label: 'Imagem do sangramento',
  },
  { icon: <IoMdMic />, label: 'Descrição em áudio' },
  { icon: <IoMdText />, label: 'Descrição em texto' },
];

function NavBar({ active, setActive, data }) {
  return (
    <Container>
      {options.map(({ icon, label }, index) => (
        <Tooltip
          title="Não disponível, informação não inserida"
          key={index}
          disableHoverListener={!!data[index]}
        >
          <div>
            <ButtonItem
              onClick={() => setActive(index)}
              active={active === index}
              disabled={!data[index]}
              icon={icon}
            >
              {label}
            </ButtonItem>
          </div>
        </Tooltip>
      ))}
    </Container>
  );
}

NavBar.propTypes = {
  active: PropTypes.number.isRequired,
  setActive: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};

export default NavBar;
